import { useState, useEffect } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { uploadQueueService } from '@/services/UploadQueueService';

/**
 * Upload Queue Badge Component
 * Shows pending upload count and allows access to queue management
 */
export function UploadQueueBadge() {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const updateCount = async () => {
      const count = await uploadQueueService.getPendingCount();
      setPendingCount(count);
    };

    // Initial load
    updateCount();

    // Poll every 10 seconds for updates
    const interval = setInterval(updateCount, 10000);

    return () => clearInterval(interval);
  }, []);

  if (pendingCount === 0) return null;

  return (
    <Tooltip title={`${pendingCount} upload(s) pending`}>
      <IconButton color="inherit" size="small">
        <Badge badgeContent={pendingCount} color="warning">
          <CloudUploadIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}